module.exports = __webpack_public_path__ + "static/media/research_details.8ec0f542.jpg";